import { Scheduled } from "pages/Scheduled/Scheduled";

export default Scheduled;
